"use client";
import React from "react";

const leftItems = [
  {
    title: "Skills-Integrated Higher Education",
    id: "skills-integrated-higher-education",
    text: "Learning designed for application, not accumulation",
    text2:"Integration of skill/vocational learning with competency-based, outcome-oriented higher education",
  },
  {
    title: "Learning Ecosystem",
    id: "learning-ecosystem",
    text: "Learning that adapts to the learner, not the other way around",
    text2:"Flexible, multidisciplinary, learner-centric, choice-based education pathways",
  
  },
  {
    title: "Learning with Industry",
    id: "learning-with-industry",
    text: "Where learning involves industry exposure & experience",
    text2:"Integration of internships, on-the-job learning and Earn While You Learn models as core components",
  },
];

const rightItems = [
  {
    title: "Digital-First University",
    id: "digital-first-university",
    text: "Technology-enabled learning for a digital-first world",
    text2:"Expansion of digital and blended learning with integrated technology-enabled teaching, learning and assessment",
  },
  {
    title: "Degree + Experience",
    id: "degree-experience",
    text: "Graduate with a degree and the experience employers demand",
    text2:"Emphasis on experiential, work-based learning with strong education–employability linkage",
  },
  {
    title: "Outcome-Based & Stress-Free Evaluation",
    id: "outcome-based-stress-free-evaluation",
    text: "Assessing progress, not pressure",
    text2:"Outcome-based education with continuous, formative and multimodal assessment frameworks",
  },
];

export default function OurPedagogicalFramework() {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const headerOffset = 100; // Adjust this value based on your sticky header height
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <section className="page-container pt-5 md:pt-15 pb-5 md:pb-12.5">
      <div className="">
        <div className="text-left mb-8">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">Our Pedagogical Framework</h2>
          <p className="mt-2 text-gray-600 max-w-3xl">A learning ecosystem designed to develop knowledge, skills, confidence and real-world readiness</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          <div className="space-y-6">
            {leftItems.map((it, idx) => (
              <div key={idx} className="bg-sky-700 text-white p-6  shadow flex flex-col justify-between">
                <div>
                  <h3 className="font-semibold">{it.title}</h3>
                  <p className="mt-2 text-md">{it.text}</p>
                  <p className="mt-3"><strong className="text-[12.5px]">NEP 2020 Alignment -{" "}</strong><span className="text-[13.5px]">{it.text2}</span></p>
                </div>
                <button onClick={() => scrollToSection(it.id)} className="mt-4 text-sm font-bold text-left cursor-pointer flex items-center gap-1 hover:text-amber-300 transition-colors">
                  Read More <span className="inline-block rotate-45">&rarr;</span>
                </button>
              </div>
            ))}
          </div>

          <div className="flex justify-center">
            {/* <div className="w-56 h-56 bg-white border shadow-md rounded flex flex-col items-center justify-center">
              <div className="text-center">
                <div className="mb-2 inline-block">
                  <img src="/assets/frontend_assets/images/msu-logo.png" alt="Medhavi Logo" className="w-28 h-auto" />
                </div>
                <div className="text-sm font-medium text-gray-700">NEP 2020 Alignment</div>
              </div>
            </div> */}
            <img src="https://cdn.msu.edu.in/msu-reavamp/Pedagogy/medhavi-pedagogy-logo.png" alt="" />
          </div>

          <div className="space-y-6">
            {rightItems.map((it, idx) => (
              <div key={idx} className="bg-amber-500 text-black p-6  shadow flex flex-col justify-between">
                <div>
                  <h3 className="font-semibold">{it.title}</h3>
                  <p className="mt-2 text-sm">{it.text}</p>
                  <p className="mt-3"><strong className="text-[12.5px]">NEP 2020 Alignment -{" "}</strong><span className="text-[13.5px]">{it.text2}</span></p>
                </div>
                <button onClick={() => scrollToSection(it.id)} className="mt-4 text-sm font-bold text-left cursor-pointer flex items-center gap-1 hover:text-sky-800 transition-colors">
                  Read More <span className="inline-block rotate-45">&rarr;</span>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
